module.exports = __webpack_public_path__ + "img/sleeve lower flounce opening.afb66928.png";